import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1db8e092&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=1db8e092&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db8e092",
  null
  
)

export default component.exports